import React, { useEffect, useState, useCallback } from "react";
import { Table } from "antd";
import { itemRender, pageSizeOptions, defaultPagination, handlePageChange } from "utils/table";
import { getUniformStockApi } from "api/services/uniforms";
import StockHistoryFilter from "../components/StockHistoryFilter";
import StockHistoryFilterDrawer from "components/Drawer/stockHistoryFilterDrawer";
import useStockHistoryFilter from "../hooks/stockHistoryFilterHook";
import { format } from "date-fns";
import { formatDateHandler2, formatDateWithTimeHandler } from "utils/common";
const StockHistoryTable = ({ uniformId, refreshTrigger }) => {
  const [loading, setLoading] = useState(false);
  const [stockHistoryData, setStockHistoryData] = useState([]);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [pageSettings, setPageSettings] = useState({
    ...defaultPagination,
    page: 1,
    pageSize: 10,
    sortType: "",
    sortBy: ""
  });

  const {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading,
    setFilterLoading,
    handleDateChange
  } = useStockHistoryFilter(pageSettings, setPageSettings);

  const getFilterParams = useCallback(() => {
    let _filters = [...filters].filter(item => item.value);
    const filter_params = _filters.reduce((acc, item) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
    return filter_params;
  }, [filters]);

  const getStockHistory = () => {
    if (!uniformId) return;

    setLoading(true);
    setFilterLoading(true);
    
    let filter_params = getFilterParams();
    
    // Format date if present
    if (filter_params?.stock_date) {
      filter_params.stock_date = format(new Date(filter_params.stock_date), "yyyy-MM-dd");
    }
    let ordering = ""
    if(pageSettings?.sortType === "ascend"){
        ordering = "-" + pageSettings?.sortBy;
    } else {
        ordering = pageSettings?.sortBy;
    }
    console.log(ordering, "ordering---->>>");

    getUniformStockApi({
      uniform: uniformId,
      ordering,
      page_size: pageSettings?.pageSize,
      page: pageSettings?.page,
      ...filter_params
    })
      .then(response => {
        console.log(response.data, "stock history---->>>");
        setStockHistoryData(response.data.results || response.data);
        setPageSettings({
          ...pageSettings,
          total: response.data.count || response.data.length
        });
        setLoading(false);
        setFilterLoading(false);
        setShowFilterDrawer(false);
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
        setFilterLoading(false);
      });
  };

  useEffect(() => {
    getStockHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniformId, pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, refreshTrigger]);

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings);
    console.log(pageData);
    setPageSettings(pageData);
  };

  const handleFilterDrawer = () => {
    setShowFilterDrawer(!showFilterDrawer);
    setFilterLoading(false);
  };

  const handleApplyFilter = () => {
    setPageSettings({
      ...pageSettings,
      page: 1,
      filters
    });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.id}
        </span>
      )
    },
    
    {
      title: "Size",
      dataIndex: "size_name",
      sorter: true,
      render: (text, record) => (
        <span className="badge badge-soft-secondary px-2 py-1">
          {record?.size?.code || ""}
        </span>
      )
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.quantity || 0}
        </span>
      )
    },
    {
      title: "Stock Date",
      dataIndex: "stock_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.stock_date) || "-"}
        </span>
      )
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateWithTimeHandler(record.created_at) || "-"}
        </span>
      )
    },
    {
      title: "Created By",
      dataIndex: "created_by_name",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.created_by 
            ? `${record.created_by.first_name || ''} ${record.created_by.last_name || ''}`.trim() || "-"
            : "-"}
        </span>
      )
    },
    {
      title: "Notes",
      dataIndex: "notes",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record.notes || "-"}
        </span>
      )
    }
  ];

  return (
    <>
      <div className="card mb-0 mt-4">
        <div className="card-body">
          <h4 className="card-title mb-3">Stock Take History</h4>
          
          <StockHistoryFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Stock History"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />

          <div className="row">
            <div className="table-responsive">
              <Table
                className="table-striped"
                columns={columns}
                dataSource={stockHistoryData}
                rowKey={(record) => record.id}
                loading={loading}
                pagination={{
                  total: pageSettings?.total,
                  pageSize: pageSettings?.pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: pageSizeOptions,
                  itemRender: itemRender,
                  position: "bottom-right",
                  current: pageSettings?.page,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                }}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>

      <StockHistoryFilterDrawer
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      />
    </>
  );
};

export default StockHistoryTable;

